import {get} from 'lodash'

export default {
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    getGmailTokens (gapi) {
      return {
        userEmail: get(this.userInfo, 'email', '')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getGmailTokens.js